<div tds-tile variant="auto" class="region-manager-section">
  <h2 class="no-margin">{{ source().name }}</h2>
  <tds-segmented-control [(selectedIndex)]="selectedTab">
    <button tds-segmented-control-option>Active Region Manager</button>
    <button tds-segmented-control-option>Former Region Manager</button>
  </tds-segmented-control>

  @if (selectedTab() === 0) {
    <div class="region-manager-toolbar">
      <button tds-button variant="primary" (click)="openCreate()">Add</button>
    </div>
    <table class="region-manager-table">
      <thead>
        <tr>
          <th>Full name</th>
          <th>Email</th>
          <th>Market Area</th>
          <th>Start date</th>
          <th>Added by</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        @for (regionManager of activeRegionManagers(); track regionManager.id) {
          <tr>
            <td>{{ fullName(regionManager) }}</td>
            <td>{{ regionManager.email }}</td>
            <td>{{ marketAreaLabel(regionManager) }}</td>
            <td>{{ formatDate(regionManager.startDate) }}</td>
            <td>{{ regionManager.addedByEmail }}</td>
            <td><button tds-button variant="secondary-danger" (click)="remove(regionManager)">Remove</button></td>
          </tr>
        } @empty {
          <tr><td colspan="6">No active Region Manager.</td></tr>
        }
      </tbody>
    </table>
  }

  @if (selectedTab() === 1) {
    <table class="region-manager-table">
      <thead>
        <tr>
          <th>Full name</th>
          <th>Email</th>
          <th>Market Area</th>
          <th>Start date</th>
          <th>Added by</th>
          <th>End date</th>
          <th>Removed by</th>
        </tr>
      </thead>
      <tbody>
        @for (regionManager of formerRegionManagers(); track regionManager.id) {
          <tr>
            <td>{{ fullName(regionManager) }}</td>
            <td>{{ regionManager.email }}</td>
            <td>{{ marketAreaLabel(regionManager) }}</td>
            <td>{{ formatDate(regionManager.startDate) }}</td>
            <td>{{ regionManager.addedByEmail }}</td>
            <td>{{ formatDate(regionManager.endDate) }}</td>
            <td>{{ regionManager.removedByEmail }}</td>
          </tr>
        } @empty {
          <tr><td colspan="7">No former Region Manager.</td></tr>
        }
      </tbody>
    </table>
  }
</div>

